import { render } from "./Property.vue?vue&type=template&id=05658f40&scoped=true&ts=true"
import script from "./Property.vue?vue&type=script&lang=ts"
export * from "./Property.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05658f40"]])

export default __exports__